import dialog from '../../versa/dialog.js';
import front from '../version.js';
import api from '../api.js';
import changelog from '../changelog.js';

function formatChangelog(entries) {
	/** Número de blocos (por data) exibidos no Sobre. */
	const MAX_DAYS = 10;
	const slice = entries.slice(0, MAX_DAYS);
	return slice.map(e => {
		const ch = (e.changes && e.changes.length) ? e.changes.join('\n') : '-----';
		const ad = (e.add && e.add.length) ? e.add.join('\n') : '-----';
		const bf = (e.bugfix && e.bugfix.length) ? e.bugfix.join('\n') : '-----';
		return `${e.date}\n\nALTERAÇÕES\n${ch}\n\nNOVIDADES\n${ad}\n\nCORREÇÕES\n${bf}`;
	}).join('\n\n─────────────────\n\n');
}

const about = async function()
{
	let back = await api.call(api.version);
	const logText = formatChangelog(changelog);

	let html = `
		<style>
			#about .about-logos { display: flex; align-items: center; justify-content: center; gap: var(--space-lg); flex-wrap: wrap; }
			#about img.logo-sial { width: 200px; }
			#about img.logo-machadotec { width: 180px; height: auto; }
			#about .about-versions { margin-top: var(--space-md); margin-bottom: var(--space-md); }
			#about .about-changelog {
				margin-top: var(--space-md);
				margin-bottom: var(--space-md);
				max-height: 240px;
				overflow-y: auto;
				padding: var(--space-sm);
				background: var(--bg-secondary, #f8f9fa);
				border: 1px solid var(--border-color, #dee2e6);
				border-radius: 6px;
				font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
				font-size: 0.88rem;
				line-height: 1.5;
				white-space: pre-wrap;
				word-break: break-word;
			}
		</style>
		<div id="about" class="msgbox">
			<div class="about-logos">
				<img src="img/logo_v.png" class="logo-sial" alt="SIAL">
				<img src="img/logo_machadotec.png" class="logo-machadotec" alt="MachadoTec">
			</div>
			<div class="about-versions">
				Frontend: ${front}<br/>
				Backend: ${back}<br/>
				Desenvolvido para LLT Consultoria<br/>
				MachadoTec Software Solutions
			</div>
			<div class="about-changelog" readonly>${logText.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>
			<button class="bn_Enter button">Fechar</button>
		</div>`;

	let dlg = dialog.create(html, () => dlg.destroy(), /Enter|Escape/);
}

export default about;

